import z from "zod";

export const IncidentTypeValues = ["136", "mca", "voluntary", "other"] as const;

export type IncidentType = (typeof IncidentTypeValues)[number];

export const IncidentTypeSchema = z.enum({
  section136: "136",
  mentalCapacityAct: "mca",
  voluntary: "voluntary",
  other: "other",
} satisfies Record<string, IncidentType>);
